import { render, staticRenderFns } from "./WebsiteOrder.vue?vue&type=template&id=1065bf22&scoped=true&"
import script from "./WebsiteOrder.vue?vue&type=script&lang=js&"
export * from "./WebsiteOrder.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteOrder.vue?vue&type=style&index=0&id=1065bf22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1065bf22",
  null
  
)

export default component.exports